
import "slick-carousel";
import {AuwSlider} from "./AuwSlider";

if($('.slider').length) {
    $.each($('.slider'),function(i,e){
        new AuwSlider($(e));
    });
}

